const outlinedOnSurfaceSx = hoverBackground => ({
    color: 'inherit',
    borderColor: 'currentColor',
    textTransform: 'none',
    fontWeight: 600,
    '&:hover': {
        borderColor: 'currentColor',
        bgcolor: hoverBackground,
    },
});

export default outlinedOnSurfaceSx;
